"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _RemoveCircle = _interopRequireDefault(require("@material-ui/icons/RemoveCircle"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _PrimusImageAnnotate = _interopRequireDefault(require("./PrimusImageAnnotate"));

var _Module = require("../../Module");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  figure: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(.5),
    width: theme.spacing(24),
    height: theme.spacing(24),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(32),
      width: theme.spacing(32),
      height: theme.spacing(32)
    }
  },
  image: {
    display: "block",
    maxWidth: "90%",
    maxHeight: "90%"
  },
  action: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(32),
      width: theme.spacing(32),
      height: theme.spacing(32)
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 1,
    "&:hover": {
      opacity: 1
    }
  },
  remove: {
    position: "absolute",
    top: 0,
    right: 0
  },
  removeIcon: {
    fontSize: "18px"
  },
  edit: {
    backgroundColor: "rgba(255,255,255,.5)",
    "&:hover": {
      backgroundColor: "white"
    }
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: theme.spacing(.5),
    overflow: "hidden",
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "bold"
  }
}));

const PrimusImage = (_ref) => {
  let id = _ref.id,
      currentId = _ref.currentId,
      expanded = _ref.expanded,
      mediaId = _ref.mediaId,
      media = _ref.media,
      onEdit = _ref.onEdit,
      onRemove = _ref.onRemove,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "currentId", "expanded", "mediaId", "media", "onEdit", "onRemove"]);

  const classes = useStyles();
  const title = media && media.title;
  const imageUrl = media && media.imageUrl;
  const count = Math.round(Math.random() * 10);

  if (id === currentId) {
    return _react.default.createElement(_PrimusImageAnnotate.default, _extends({
      mediaId: mediaId,
      media: media
    }, props));
  }

  return _react.default.createElement("article", {
    className: classes.root
  }, _react.default.createElement(_Paper.default, {
    square: true,
    className: classes.figure
  }, _react.default.createElement("img", {
    src: imageUrl,
    className: classes.image
  }), _react.default.createElement("nav", {
    className: classes.action
  }, _react.default.createElement(_IconButton.default, {
    className: classes.edit,
    onClick: onEdit
  }, _react.default.createElement(_Edit.default, null)), _react.default.createElement(_IconButton.default, {
    className: classes.remove
  }, _react.default.createElement(_RemoveCircle.default, {
    className: classes.removeIcon,
    onClick: onRemove
  })))), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_Typography.default, {
    className: classes.title,
    component: "h2",
    noWrap: true
  }, title), _react.default.createElement(_Module.ModuleLabel, {
    backgroundColor: "#6AACF4",
    borderColor: "#6AACF4",
    textColor: "white",
    label: count
  })));
};

var _default = PrimusImage;
exports.default = _default;
module.exports = exports.default;